import React, { useContext, useEffect } from 'react';
import CreateASpoolContext from '../../../../context/createASpool/createASpoolContext';
import { RiskModelType } from '../../../../context/createASpool/createASpoolType';
import CollapsibleArea from '../../../../components/CollapsibleArea';
import { TableRow } from '../../../../components/Table';
import { TabsContext } from '../../../../components/Tabs';
import RiskModelAccordionContent from './RiskModelAccordionContent';
import { formatPercentages } from '../../../../helpers/formats';
import appContext from '../../../../context/app/appContext';

type Props = {
    riskModel: RiskModelType;
    collapsed: boolean;
    toggle: () => void;
};

const RiskModelAccordion: React.FC<Props> = ({ riskModel, collapsed, toggle }) => {
    const { address, feeOnYield } = riskModel;

    const { updateHeight } = useContext(TabsContext);
    const { selectedRiskModel, setSelectedRiskModel } = useContext(CreateASpoolContext);
    const { chainRiskModels } = useContext(appContext);

    useEffect(() => {
        updateHeight();
    }, [collapsed, updateHeight]);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setSelectedRiskModel(e.target.value);
    };

    return (
        <TableRow className={collapsed ? 'collapsed' : ''}>
            <div className='row-container' onClick={toggle}>
                <div>
                    <div className='arrow-container'>
                        <div className='arrow' />
                    </div>
                    <span>{chainRiskModels[address]?.name ?? 'Risk Model'}</span>
                </div>
                <div>
                    {chainRiskModels[address]?.creator ?? 'Creator'}
                    <span className='column-label'>Creator</span>
                </div>
                <div>
                    {formatPercentages(feeOnYield || 0)}%
                    <span className='column-label'>Fee on Yield</span>
                </div>
                <div>
                    <label className={selectedRiskModel === address ? 'active' : ''}>
                        <input
                            type='radio'
                            name='riskModelAddress'
                            value={address}
                            onChange={handleChange}
                            checked={selectedRiskModel === address}
                        />
                    </label>
                    <span className='column-label'>Select one</span>
                </div>
            </div>
            <CollapsibleArea
                unMountOnExit
                className='accordion-content'
                collapsed={collapsed}
            >
                <RiskModelAccordionContent riskModel={riskModel} />
            </CollapsibleArea>
        </TableRow>
    );
};

export default RiskModelAccordion;
